export const ContentTypes = {
  Text: 'richtext',
  Features: 'features',
  Image: 'imagecontentblock',
  Video: 'video',
  SplitImage: 'splitimage',
  SplitVideo: 'splitvideo',
  PapBookNowButton: 'priorityaccesspassbooknowbutton',
  SingleMapPin: 'singlemappin',
};

export { default as Features } from './Features';
export { default as Image } from './Image';
export { default as PapBookNowButton } from './PapBookNowButton';
export { default as SplitImage } from './SplitImage';
export { default as SplitVideo } from './SplitVideo';
export { default as Text } from './Text';
export { default as Video } from './Video';
export { default as SingleMapPin } from './SingleMapPin';
